import Lottie from "lottie-react";
import { yetiStudentLogin } from "../../../../appAssets";
import saveJournalJson from "../../../../appAssets/jsons/save_journal.json";
import { JOURNAL_STRINGS } from "../../types";
import closeIcon from "../../../../appAssets/closeIcon.png";
import "./CreateWorkPopup.scss";

interface CreateWorkPopupProps {
  onOkay: () => void;
  onClose: () => void;
}

/**
 * Mirrors srcMobile/Screens/KidsJournal/components/CreateWorkPopup
 * Shown when the user tries to save without writing/recording anything.
 */
function CreateWorkPopup({ onOkay, onClose }: CreateWorkPopupProps) {
  return (
    <div className="create-work">
      <div className="create-work__card">
        <div className="create-work__inner">
          <div className="create-work__header">
            <p className="create-work__title">{JOURNAL_STRINGS.noWorkToSave}</p>
            <button
              type="button"
              className="create-work__close"
              onClick={onClose}
              aria-label="Close"
            >
              <img
                src={closeIcon}
                alt="Close"
                className="breathe__close-icon"
              />
            </button>
          </div>

          <Lottie
            animationData={saveJournalJson}
            loop={false}
            autoplay
            className="create-work__icon"
          />

          <button type="button" className="create-work__okay" onClick={onOkay}>
            Okay
          </button>
        </div>
        <img src={yetiStudentLogin} alt="" className="create-work__yeti" />
      </div>
    </div>
  );
}

export default CreateWorkPopup;
